class CopyClipboard {

    constructor() {
      this.copyValue = document.querySelector('.js-copy-clipboard a')
      this.copyButton = document.querySelector('.js-copy-clipboard-button')
    }
  
    init() {
      this.events()
    }
  
    events() {

		if ( this.copyButton ) {
			
			this.copyButton.addEventListener('click', () => {
				this.copyToClipboard()
			})

		}
  
    }

	copyToClipboard() {
		navigator.clipboard.writeText( this.copyValue.href )
		this.copyButton.innerHTML = this.copyButton.dataset.copied
	}
    

  }
  
  export default CopyClipboard
  